module.exports = __webpack_public_path__ + "images/backgrounds/ocean/large.ede6927e92b4515102b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/ocean/large.jpg
// module id = cswx
// module chunks = 24